import { render, staticRenderFns } from "./UserAccountCoordinator.vue?vue&type=template&id=71d1ba74&"
import script from "./UserAccountCoordinator.vue?vue&type=script&lang=js&"
export * from "./UserAccountCoordinator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports